module.exports = __webpack_public_path__ + "img/logo.47424d82.png";